import React, { useState } from "react";
import { Alert } from "reactstrap";
import { Link } from "react-router-dom";
import config from "config";
const LastModificationAlertShow = ({ path }) => {
  const backUrl = config.backOffice.url;
  const lastId = localStorage.getItem("lastId");
  const [show, setShow] = useState(true);
  return (
    <Alert
      isOpen={show}
      toggle={() => {
        setShow(false);
        localStorage.removeItem("lastId");
        localStorage.setItem("key", false);
      }}
    >
      <Link
        to={
          path === `fx_paiements`
            ? `${backUrl}/${path}/${lastId}/apercu_facture`
            : `${backUrl}/${path}`
        }
        className="alert-link"
        onClick={() => {
          localStorage.removeItem("lastId");
        }}
        style={{ cursor: "pointer" }}
      >
        <u>Voir la dernière modification</u>
      </Link>
    </Alert>
  );
};

export default LastModificationAlertShow;
